import type { AxiosInstance } from "axios";
import type { InterceptorConfig } from "./types";
import {
  createRequestInterceptor,
  createRequestErrorHandler,
} from "./request-interceptor";
import {
  createResponseHandler,
  createResponseErrorHandler,
} from "./response-interceptor";

export * from "./types";
export * from "./errors";
export * from "./cross-tab";
export {
  broadcastLogout,
  broadcastLogin,
  subscribeToAuthSync,
  resetRefreshState,
} from "./response-interceptor";
export type { HeaderRule } from "./types";
export type { CrossTabSync, CrossTabMessage } from "./cross-tab/types";

export function setupInterceptors(
  instance: AxiosInstance,
  config: InterceptorConfig = {},
): void {
  if (config.baseURL) {
    instance.defaults.baseURL = config.baseURL;
  }

  if (config.timeout) {
    instance.defaults.timeout = config.timeout;
  }

  instance.interceptors.request.use(
    createRequestInterceptor(config),
    createRequestErrorHandler(config),
  );

  instance.interceptors.response.use(
    createResponseHandler(config),
    createResponseErrorHandler(instance, config),
  );
}

export function createTokenStorage(options: {
  getAccessToken: () => string | null | Promise<string | null>;
  getRefreshToken?: () => string | null | Promise<string | null>;
  setTokens: (
    accessToken: string,
    refreshToken?: string,
  ) => void | Promise<void>;
  clearTokens: () => void | Promise<void>;
}): InterceptorConfig["tokenStorage"] {
  return {
    getAccessToken: options.getAccessToken,
    getRefreshToken: options.getRefreshToken || (() => null),
    setTokens: options.setTokens,
    clearTokens: options.clearTokens,
  };
}
